<template>
  <VRow justify="center">
    <!-- eslint-disable vue/no-v-html -->
    <VCol cols="12" md="5" lg="4" class="questions">
      <VDivider vertical class="d-none d-md-block float-right" />
      <template
        v-for="(slide, i) in items"
      >
        <div
          :key="'q'+i"
          class="question"
          :class="[i === active ? 'active' : '']"
          @click="active = i"
        >
          <span :class="[i === active ? 'active' : 'pseudo-link primary--text']">
            {{ slide.question }}
          </span>
        </div>
        <div v-show="i === active" :key="'a'+i" class="answer d-md-none" v-html="slide.answer" />
      </template>
    </VCol>
    <VCol cols="7" lg="8" class="answers d-none d-md-block">
      <div
        v-for="(slide, i) in items"
        v-show="i === active"
        :key="'u'+i"
        class="answer"
        v-html="slide.answer"
      />
    </VCol>
  </VRow>
</template>

<script>
export default {
  name: 'FaqSlider',
  data() {
    return {
      active: 0,
    };
  },
  computed: {
    items() {
      return [
        {
          question: this.$t('costQuestion'),
          answer: `<p>${this.$t('costAnswer1')}</p>`
            + '<ul class="mb-2">'
            + `  <li>${this.$t('costAnswer2')}</li>`
            + `  <li>${this.$t('costAnswer3')}</li>`
            + `  <li>${this.$t('costAnswer4')}</li>`
            + `  <li>${this.$t('costAnswer5')}</li>`
            + '</ul>',
          mobile: `<p>${this.$t('costMobile')}</p>`,
        },
        {
          question: this.$t('advantageQuestion'),
          answer: `
            <p>${this.$t('advantageAnswer1')}</p>
            <p>${this.$t('advantageAnswer2')}</p>
            <p>${this.$t('advantageAnswer3')}</p>
            `,
          mobile: `<p>${this.$t('advantageMobile')}</p>`,
        },
        {
          question: this.$t('positionsQuestion'),
          answer: `
            <p>${this.$t('positionsAnswer1')}</p>
            <p>${this.$t('positionsAnswer2')}</p>
            <p>${this.$t('positionsAnswer3')}</p>
            <p>${this.$t('positionsAnswer4')}</p>
          `,
          mobile: `<p>${this.$t('positionsMobile')}</p>`,
        },
        {
          question: this.$t('diffucultyQuestion'),
          answer: `
            <p>${this.$t('diffucultyAnswer1')}</p>
            <p>${this.$t('diffucultyAnswer2')}</p>
            <p>${this.$t('diffucultyAnswer3')}</p>
          `,
          mobile: `<p>${this.$t('diffucultyMobile')}</p>`,
        },
        {
          question: this.$t('paymentQuestion'),
          answer: `
            <p>${this.$t('paymentAnswer1')}</p>
            <p>${this.$t('paymentAnswer2')}</p>
          `,
          mobile: `<p>${this.$t('paymentMobile')}</p>`,
        },
      ];
    },
  },
};
</script>

<style scoped lang="scss">
  .question {
    border-radius: 5px;
    font-size: 16px;
    padding: $spacer * 2;
    padding-left: 0;
    margin-bottom: $spacer * 2;
    .pseudo-link {
      font-size: inherit;
    }
    &.active {
      box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.25);
      padding-left: $spacer * 3;
      min-height: 70px;
      display: flex;
      align-items: center;
      background: #fff;
      margin-bottom: $spacer * 7;
    }
  }
  .answer {
    line-height: 1.6;
    padding-bottom: $spacer * 3;
  }
  @media #{map-get($display-breakpoints, 'md-and-up')} {
    .questions {
      hr {
        margin: $spacer * 3 0;
        min-height: calc(100% - #{$spacer * 3});
      }
    }
    .question {
      padding-left: 20px;
      width: 277px;
      border-radius: 5px;
      font-size: 16px;
      margin-bottom: $spacer * 3;
      &.active {
        margin-bottom: $spacer * 3;
      }
      &:last-child {
        margin-bottom: 0;
      }
    }
    .answers {
      padding-left: $spacer * 3;
    }
    .answer {
      padding-bottom: 0;
    }
  }
  @media #{map-get($display-breakpoints, 'lg-and-up')} {
    .answers {
      padding-left: $spacer * 22;
    }
  }
</style>

<!-- eslint-disable max-len -->
<i18n locale="en" lang="yaml">
  costQuestion: How much does the service cost?
  costAnswer1: You can view the service prices in the “Plans” section.
  costAnswer2: The “Promo” plan is best for trying out the service and finding out if the online interviews fit into your recruitment process. Some features of paid plans are unavailable in the “Promo” plan (for example, SMS notifications).
  costAnswer3: The “Small business” plan is best for small companies.
  costAnswer4: “Standard” and “Extended” plans are full-featured plans for large companies and HR agencies. Paying by cash transfer is available. It provides access to all service options that are not included in cheaper plans.
  costAnswer5: The “Unlimited” plan is best for large-scale recruitment (for example, selecting for internship programs).
  costMobile: You can see the cost of service in the Plans and Calculator section, but first users can get full access to the beta version of the system for free!
  advantageQuestion: What is the advantage of remote interviews?
  advantageAnswer1: Applicants do not have to take time out of their regular work to attend interviews. HR does not need to schedule time slots for applicants. No time is wasted if applicants are late, do not arrive, or are clearly not suited for the position.
  advantageAnswer2: Large-scale recruitment takes a huge amount of HR time. The online interview service reduces the time for routine operations and helps to focus only on those tasks that cannot be automated. As a result, recruitment time is reduced, human errors are minimized, and the cost of hiring is reduced as well.
  advantageAnswer3: Online interviews are especially effective for large-scale recruitment of remote employees, when it is physically impossible to hold a meeting in person.
  advantageMobile: The applicant does not need to leave work to come to your office. HR does not need to schedule a time slot to communicate with a candidate who may be late or may not arrive.
  positionsQuestion: What is Huntica best for?
  positionsAnswer1: Huntica is best for large-scale recruiting and selecting candidates for internships. We also significantly reduce the hiring time and cost for clients that use online interviews as a mandatory stage of recruitment. We can help set up this additional selection stage to allow clients to find only ideal applicants.
  positionsAnswer2: In addition, Huntica offers an in-person interview recording feature that allows managers to view interviews conducted by HR and not have to attend those interviews in person. HR records the interview on a webcam, and the recording can be viewed later by everyone involved in the recruitment decision. Moreover, those involved in the hiring process can view recordings at any time and add their comments to an applicant's status – no more post-it notes!
  positionsAnswer3: In the fall of 2020, we plan to introduce a package with a webcam on a tripod, which will make the in-person interview recording process even easier and more convenient.
  positionsAnswer4: Please follow our announcements on the website!
  positionsMobile: The service is best suited for large-scale recruitment and selection of internship candidates. But some of our clients use online interviews as one of the recruitment stages of for most of their jobs.
  diffucultyQuestion: Is it difficult to integrate Huntica into the recruitment process?
  diffucultyAnswer1: Huntica can be easily integrated into any recruitment procedure.
  diffucultyAnswer2: The service helps organize the recruitment process by updating an applicant's status, sending notifications, and other features. However, if you use a different service as your main recruiting platform, you can still use Huntica for its unique video interview features.
  diffucultyAnswer3: It takes only a couple of minutes to sign up and post your first job!
  diffucultyMobile: The process of registering and creating the first job takes several minutes. You can invite candidates for an online interview directly from the job site using the Google Chrome extension.
  paymentQuestion: Can I pay for your services with a card or by cash transfer?
  paymentAnswer1: You can pay for the service using a card. For the “Standard” plan and higher, payment by cash transfer is available as well.
  paymentAnswer2: You are eligible for discounts when paying for a subscription of a longer period. The maximum discount when paying for 12 months is 20%.
  paymentMobile: The system is currently in beta-testing mode and is completely free to use. Payment by bank account and cash transfer will be available after the product launch.
</i18n>

<i18n locale="ru" lang="yaml">
  costQuestion: Сколько стоит использование сервиса?
  costAnswer1: Стоимость обслуживания вы можете посмотреть в разделе Тарифы.
  costAnswer2: Тариф «Промо» – подходит для того, чтобы попробовать сервис и понять, насколько формат онлайн-собеседований вписывается в ваш процесс найма. В промо-тарифе отсутствуют некоторые возможности платных тарифов (например, СМС-оповещения).
  costAnswer3: Тариф «Малый Бизнес» - подходит для небольших компаний. Есть возможность оплаты банковской картой, но перевод по безналу недоступен.
  costAnswer4: Тарифы «Стандартный» и «Расширенный» - полнофункциональные тарифы для крупных компаний и HR-агентств. Есть возможность оплаты по безналу. Доступ ко всем опциям сервиса, которые отсутствуют в младших тарифах.
  costAnswer5: Тариф «Безлимитный» подходит для массового найма. Например, это могут быть задачи по отбору на программы стажировок.
  costMobile: Стоимость обслуживания вы можете посмотреть в разделе Тарифы и Калькулятор, но первые пользователи могут получить полноценный доступ к бета-версии системы бесплатно!
  advantageQuestion: В чем преимущество удаленных собеседований?
  advantageAnswer1: Соискателю не нужно отпрашиваться с работы, чтобы приехать к вам в офис. HR не нужно планировать временной слот для общения с кандидатом, который к тому же может опоздать или не приехать. Не придётся больше отсиживать заведомо провальные интервью.
  advantageAnswer2: Массовый найм требует колоссального количества времени HR. Сервис онлайн-собеседований позволяет в разы сократить время на рутинные операции и сосредоточить усилия только на тех задачах, которые не поддаются автоматизации. В результате время найма сокращается, ошибки, связанные с человеческим фактором, сводятся к минимуму, а стоимость закрытия одной позиции снижается.
  advantageAnswer3: Особенно эффективны онлайн-собеседования для массового найма удалённых сотрудников, когда провести личную встречу физически невозможно.
  advantageMobile: Соискателю не нужно отпрашиваться с работы, чтобы приехать к вам в офис. HR не нужно планировать временной слот для общения с кандидатом, который к тому же может опоздать или не приехать.
  positionsQuestion: Для найма каких позиций лучше всего подходит сервис Huntica?
  positionsAnswer1: Лучше всего сервис подходит для найма на массовые позиции и отбора кандидатов на стажировку. Но среди наших клиентов есть и такие, кто использует онлайн-интервью как один из обязательных этапов найма для большей части своих вакансий, так как дополнительный этап отбора позволяет находить наиболее замотивированных кандидатов.
  positionsAnswer2: Кроме онлайн-собеседований, сервис Хантика предоставляет возможность записывать офисные интервью. Этот функционал позволяет руководителям не присутствовать лично на собеседованиях. HR проводит очное интервью и записывает его на веб-камеру, а запись могут позже посмотреть все, кто принимает участие в решении о найме. Причём сделать это они могут в любое удобное время и оставить свои комментарии в карточке кандидата – больше никаких бумаг с пометками на полях!
  positionsAnswer3: Весной 2020 года мы планируем предложить нашим клиентам коробочное решение с вебкамерой на штативе, которое сделает запись офисных собеседований ещё проще и удобнее.
  positionsAnswer4: Следите за анонсами на сайте!
  positionsMobile: Лучше всего сервис подходит для найма на массовые позиции и отбора кандидатов на стажировку. Но среди наших клиентов есть и такие, кто использует онлайн-интервью как один из этапов найма для большей части своих вакансий.
  diffucultyQuestion: Сложно ли интегрировать Huntica в мой процесс найма?
  diffucultyAnswer1: Сервис Huntica станет органичным дополнением к вашему текущему процессу найма.
  diffucultyAnswer2: Сервис имеет все возможности для организации процесса найма (смена статусов кандидатов, оповещения и другие возможности), но если в качестве основной платформы вы используете другой сервис, то Хантику можно использовать просто для просмотра видео-собеседований.
  diffucultyAnswer3: Процесс регистрации и создания первой вакансии занимает несколько минут. Приглашать кандидатов на онлайн-собеседование можно прямо с hh.ru, если воспользоваться специальным расширением для Google Chrome.
  diffucultyMobile: Процесс регистрации и создания первой вакансии занимает несколько минут. Приглашать кандидатов на онлайн-собеседование можно прямо с job-сайта, если воспользоваться специальным расширением для Google Chrome.
  paymentQuestion: Можно ли оплатить ваши услуги с карты / по безналу?
  paymentAnswer1: Оплатить использование сервиса можно банковской картой. Для тарифов «Стандартный» и выше доступна оплата по безналу.
  paymentAnswer2: Действует система скидок при оплате подписки на длительный период. Максимальная скидка при оплате за 12 месяцев составляет 20%.
  paymentMobile: На данный момент система находится в режиме бета-тестирования и использование сервиса полностью бесплатно. После запуска продукта будет доступна оплата картой и по безналу.
</i18n>
<!-- eslint-enable max-len -->
